module.exports = __webpack_public_path__ + "img/second-2-opened.398f49f2.webp";